import { notAcceptedEmailApi } from "@/providers/apis/not-accepted-email-form";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import PreviewPopupComponent from "../preview-popup/preview-popup.component.vue";
import ErrorPopupComponent from "../error-popup/error-popup.component.vue";
import { utils } from "@/utils/utils";
import { appConfigService } from "@/providers/services/app/app-config";
import moment from "moment";

@Component({
  name: "email-modal-popup",
  components: {
    PreviewPopupComponent,
    ErrorPopupComponent,
  },
})
export default class EmailModalPopupComponent extends Vue {
  @Prop()
  public applicationEmailData: any;

  public applicationId: any;
  public toEmail: any;
  public chips: any = [];
  public file: any = null;
  public files: File[] = [];
  public previewFile!: any;
  public messageInput = "";
  public subjectInput = "";
  public set = {
    type: true,
    default: true,
  };
  public isSending = false;
  public sentEmailHistory: any = [];
  public isLoading = true;
  public checkValid = false;
  public previewFileData: any[] = [];
  public showPreviewPopup = false;
  public imgType = ["jpg", "png", "jpeg", "tiff"];
  public S3Path = "";
  public errorMessage = "";

  public created() {
    this.S3Path = appConfigService.getS3FilesPathUrl();
    if (this.applicationEmailData) {
      const applicantDetials = this.applicationEmailData.item;
      if (applicantDetials.applicationName === "PART ONE") {
        this.applicationEmailData.item.email =
          this.applicationEmailData.item.data.certificationPartOneBasicDetails.email;
      }
      if (applicantDetials.applicationName === "PART TWO") {
        this.applicationEmailData.item.email =
          this.applicationEmailData.item.data.certificationPartTwoApplicationForm.email;
      }
      if (applicantDetials.applicationName === "RENEWAL") {
        this.applicationEmailData.item.email =
          this.applicationEmailData.item.data.renewalApplicationInformation.email;
      }
      this.toEmail = applicantDetials.email;
      this.applicationId = applicantDetials.id;
    }
  }

  public async onSendEmail() {
    this.checkValid = true;
    this.$validator.validate().then((validate: any) => {
      if (validate) {
        this.checkValid = false;
        this.isSending = true;
        const formdata = new FormData();
        formdata.append("applicationId", this.applicationId);
        formdata.append("email", this.toEmail);
        formdata.append("ccAddress", this.chips);
        formdata.append("subject", this.subjectInput);
        formdata.append(
          "message",
          JSON.parse(
            utils.textAreaTagsConversion(JSON.stringify(this.messageInput))
          )
        );
        for (let index = 0; index < this.files.length; index++) {
          formdata.append("files", this.files[index]);
        }
        notAcceptedEmailApi
          .sendEmailData(formdata)
          .then((data) => {
            this.isSending = false;
            this.$emit("emailSended", true);
          })
          .catch(() => {
            this.$emit("emailSended", false);
            this.isSending = false;
          });
      }
    });
  }

  public onGetEmailHistory() {
    notAcceptedEmailApi
      .getEmailHistory(this.applicationId)
      .then((result) => {
        this.sentEmailHistory = result.data.data;
        this.sentEmailHistory.map((history: any) => {
          history.receivedDate = moment(history.receivedDate).format(
            "MM-DD-YYYY HH:mm:ss:SSS"
          );
        });
        this.isLoading = false;
      })
      .catch((e) => {
        this.isLoading = false;
        console.error(e);
      });
  }

  public emailAttachmentPreview(index: number, attachmentIdx: number) {
    this.previewFile = this.sentEmailHistory[index].attachments[attachmentIdx];
    if (this.previewFile) {
      if (
        this.imgType.includes(this.previewFile.uploadedFileName.split(".")[1])
      ) {
        const img = new Image();
        img.src = `${this.S3Path}/${this.previewFile.uploadedFileName}`;
        this.previewFile.width = img.width;
        this.previewFile.height = img.height;
      }
      this.previewFileData = [this.previewFile];
      this.showPreviewPopup = true;
    }
  }

  public handleFileSelect(evt: any) {
    const selectedFiles = Array.from(
      (evt?.target?.files || []) as ArrayLike<File>
    );
    const allowedExtensions = ["jpg", "jpeg", "png", "pdf"];
    const invalidFiles = selectedFiles.filter((file: any) => {
      const extension = file.name.split(".").pop().toLowerCase();
      return !allowedExtensions.includes(extension);
    });

    if (invalidFiles.length > 0) {
      this.errorMessage = "Please upload files in .jpg, .png, or .pdf format.";
      if (evt?.target) {
        evt.target.value = null;
      }
      return;
    }

    selectedFiles.forEach((data: File) => {
      this.files.push(data);
    });
    if (evt?.target) {
      evt.target.value = null;
    }
  }

  public closdedErrorPopup(event: any) {
    if (event) {
      this.errorMessage = "";
    }
  }

  public preview(index: number) {
    this.previewFile = this.files[index];
    if (this.previewFile) {
      if (this.previewFile.type.split("/")[0] === "application") {
        const file = new Blob([this.previewFile], {
          type: this.previewFile.type,
        });
        const fileURL = URL.createObjectURL(file);
        this.previewFileData = [
          {
            url: fileURL,
            name: this.previewFile.name,
            type: this.previewFile.type,
          },
        ];
        this.showPreviewPopup = true;
      } else {
        const fileURL = URL.createObjectURL(this.previewFile);
        const img = new Image();
        img.src = fileURL;
        this.previewFileData = [
          {
            width: img.width,
            height: img.height,
            url: fileURL,
            name: this.previewFile.name,
            type: this.previewFile.type,
          },
        ];
        this.showPreviewPopup = true;
      }
    }
  }

  public removeImage(index: number) {
    this.files.splice(index, 1);
  }

  public getType(type: string) {
    if (type.includes("pdf") || type.includes("doc") || type.includes("docx")) {
      return "application";
    } else {
      return "image";
    }
  }

  public hidePreviewPopup(event: boolean) {
    if (event === true) {
      this.showPreviewPopup = false;
      this.previewFileData = [];
    }
  }

  public close() {
    this.$bvModal.hide("email-modal");
  }
}
